import React, { Suspense } from 'react';
import { Typography, Button, Modal, Drawer, Spin } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { isBrowser, isMobile } from 'react-device-detect';
import './HeroSection.css';

const AlumniRegistrationForm = React.lazy(() => import('../../form/FormAlumni'));
const GuestBookRegistrationForm = React.lazy(() => import('../../form/FormGuestBook'));


const ppdbWebLink = process.env.REACT_APP_PPDB_WEB_URL;
const { Title, Text } = Typography;

const LoadingFallback = () => (
  <div style={{ textAlign: 'center', padding: '20px' }}>
    <Spin tip="Memuat..." />
  </div>
);

const AboutSection = () => {
  const [visibleFormAlumni, setVisibleFormAlumni] = React.useState(false);
  const [visibleFormGuestBook, setVisibleFormGuestBook] = React.useState(false);

  const ppdbYear = new Date().getFullYear();

  // Data pengumuman - jika kosong/null/"-", sembunyikan announcement box
  const announcementText = null;
  const hasAnnouncement = announcementText && announcementText.trim() !== '' && announcementText.trim() !== '-';

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div id="home" className="hero-section">
      <div className="info-section">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, x: -50 }} // posisi awal (off-screen)
          animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }} // animasi masuk/keluar
          transition={{ duration: 0.5, ease: 'easeOut' }} // durasi dan easing animasi          
        >
          <Title level={5} className="hero-subtitle">🚀 Lebih canggih, dan lebih handal</Title>
        </motion.div>
        <motion.div
          ref={ref}
          initial={{ opacity: 0, x: -50 }} // posisi awal (off-screen)
          animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }} // animasi masuk/keluar
          transition={{ delay: 0.2, duration: 0.5, ease: 'easeOut' }} // durasi dan easing animasi          
        >
          <Title level={1} className="hero-title">Menuju MAN 4.0 Berbasis Teknologi Digital</Title>
        </motion.div>
        <motion.div
          ref={ref}
          initial={{ opacity: 0, x: -50 }} // posisi awal (off-screen)
          animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }} // animasi masuk/keluar
          transition={{ delay: 0.4, duration: 0.5, ease: 'easeOut' }} // durasi dan easing animasi          
        >
          <Text className="hero-description">
            Sistem informasi MAN Digital adalah sebuah sistem aplikasi berbasis web yang digunakan untuk membantu
            mengelola pelayanan pengelolaan data Madrasah dalam peningkatan pelayanan anggota Madrasah secara lebih
            cepat dan efisien, selain itu sistem ini akan membantu dan memudahkan dalam penambahan data pada aplikasi
            pendukung pendidikan yang resmi.
          </Text>
        </motion.div>

        <motion.div
          ref={ref}
          initial={{ opacity: 0, x: -50 }} // posisi awal (off-screen)
          animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }} // animasi masuk/keluar
          transition={{ delay: 0.6, duration: 0.5, ease: 'easeOut' }} // durasi dan easing animasi          
        >
          {/* Bagian Pengumuman - Tampil hanya jika ada pengumuman valid */}
          {hasAnnouncement && (
            <div className="announcement-box">
              <div className="announcement-content">
                <BellOutlined className="announcement-icon" />
                <div style={{ marginTop: '12px' }}>
                  <h4>Pengumuman Penting</h4>
                  <p>{announcementText}</p>
                </div>
              </div>
            </div>
          )}

          {/* Tombol Aksi */}
          <div className="hero-buttons">
            <a href={ppdbWebLink} target='_blank' rel="noopener noreferrer" className="hero-btn-link">
              <Button type="primary" className="hero-action-btn hero-btn-ppdb" block>PPDB {ppdbYear}</Button>
            </a>
            <Button className="hero-action-btn" onClick={() => setVisibleFormAlumni(!visibleFormAlumni)} block>Pendaftaran Alumni</Button>
            <Button className="hero-action-btn" onClick={() => setVisibleFormGuestBook(!visibleFormGuestBook)} block>Buku Tamu</Button>
          </div>
        </motion.div>
      </div>


      {/* Modal for Desktop */}
      {isBrowser && (
        <>
          <Modal
            maskClosable={false}
            keyboard={false}
            title="Form Registrasi Alumni"
            open={visibleFormAlumni}
            onCancel={() => setVisibleFormAlumni(false)}
            footer={null}
          >
            <Suspense fallback={<LoadingFallback />}>
              <AlumniRegistrationForm />
            </Suspense>
          </Modal>
          <Modal
            maskClosable={false}
            keyboard={false}
            title="Form Buku Tamu"
            open={visibleFormGuestBook}
            onCancel={() => setVisibleFormGuestBook(false)}
            footer={null}
          >
            <Suspense fallback={<LoadingFallback />}>
              <GuestBookRegistrationForm onClose={() => setVisibleFormGuestBook(false)} />
            </Suspense>
          </Modal>
        </>
      )}


      {/* Drawer for Mobile */}
      {isMobile && (
        <>
          <Drawer
            placement="bottom"
            height="100%"
            onClose={() => setVisibleFormAlumni(false)}
            open={visibleFormAlumni}>
            <Suspense fallback={<LoadingFallback />}>
              <AlumniRegistrationForm />
            </Suspense>
          </Drawer>
          <Drawer
            placement="bottom"
            height="100%"
            onClose={() => setVisibleFormGuestBook(false)}
            open={visibleFormGuestBook}>
            <Suspense fallback={<LoadingFallback />}>
              <GuestBookRegistrationForm onClose={() => setVisibleFormGuestBook(false)} />
            </Suspense>
          </Drawer>
        </>
      )}
    </div>
  );
};

export default AboutSection;
